export default __webpack_public_path__ + "static/tiina-240-859274362616cd89b70a8dcfcf8d7608.png";